import React, { useCallback } from 'react';
import { ReactEditor } from 'slate-react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { isMediaElement } from '../../../types/guards';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import ColorUtils from '../../../util/color';
import ToolBorderColor from './ToolBorderColor';

class ToolBorderColorPicker extends Tool {
  static toolName = ''; // No name needed for submenu tool, since we don't want a tooltip.

  static renderToolbarComponent(toolArgs: ToolArgsWithController) {
    const { editor, element } = toolArgs;

    if (!element || !isMediaElement(element)) return null;

    const mappedColor = element.media_borderColor
      ? ColorUtils.mapColorFromColorPickerToDarkMode(element.media_borderColor)
      : undefined;

    const handleColorChange = useCallback(
      (color: string, focusEditor?: boolean) => {
        ToolBorderColor.action({
          editor,
          element,
          color: color,
        });
        if (focusEditor) {
          ReactEditor.focus(editor);
        }
      },
      [editor, element]
    );

    const handleClearColor = useCallback(() => {
      ToolBorderColor.action({
        editor,
        element,
      });
      ReactEditor.focus(editor);
    }, [editor, element]);

    const handleCloseMenu = useCallback(() => {
      // Submenu will handle closing
    }, []);

    return (
      <ColorPicker
        currentColor={mappedColor ?? '#ffffff'}
        handleColorChange={handleColorChange}
        handleClearColor={handleClearColor}
        handleCloseMenu={handleCloseMenu}
        showCustomColorInput={true}
        showClearButton={true}
      />
    );
  }
}

export default ToolBorderColorPicker;
